// System fields that should not be displayed in CSV viewer
export const SYSTEM_FIELDS = [
  "id",
  "created_at",
  "updated_at",
  "project_id",
  "from_file",
];
